/** One optional product-owned recovery guard at the authenticated logout boundary. */
export interface LogoutRecoveryGuard {
  readonly principalId: string;
  readonly describe: () => string | undefined;
  readonly canSynchronize: () => boolean;
  readonly synchronize: () => Promise<boolean>;
  readonly download: () => void;
}

let current: LogoutRecoveryGuard | undefined;

export function registerLogoutRecovery(guard: LogoutRecoveryGuard): void {
  current = guard;
}

export function logoutRecoveryFor(principalId: string): LogoutRecoveryGuard | undefined {
  return current?.principalId === principalId ? current : undefined;
}

export function clearLogoutRecovery(principalId: string): void {
  if (current?.principalId === principalId) current = undefined;
}
